import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pioneer-payment-title-summary',
  templateUrl: './payment-title-summary.component.html',
})
export class PaymentTitleSummaryComponent implements OnInit {

  @Input() iconClass: string;
  @Input() title: string;
  @Input() isCompleted: boolean;
  @Input() summary: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/payment-title-summary/payment-title-summary.component.ts